/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ViewupPlusSnsAccountOnPlatform } from './viewup-plus-sns-account-on-platform';
// May contain unused imports in some cases
// @ts-ignore
import type { ViewupSnsAccountOnPlatform } from './viewup-sns-account-on-platform';

/**
 * 
 * @export
 * @interface AdminGetUserByUserUuidDataDto
 */
export interface AdminGetUserByUserUuidDataDto {
    /**
     * 유저 uuid
     * @type {string}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'userUuid': string;
    /**
     * 아이디
     * @type {string}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'id': string;
    /**
     * 닉네임
     * @type {string}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'nickname': string;
    /**
     * 유저 레벨
     * @type {string}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'level'?: AdminGetUserByUserUuidDataDtoLevelEnum;
    /**
     * 서포터즈 여부
     * @type {boolean}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'isSupporter'?: boolean;
    /**
     * 수호신 여부
     * @type {boolean}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'isGuardian'?: boolean;
    /**
     * 관리자의 해당 유저 즐겨찾기 여부
     * @type {boolean}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'isStarred'?: boolean;
    /**
     * 관리자의 해당 유저 차단 여부
     * @type {boolean}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'isBanned'?: boolean;
    /**
     * 관리자의 유저 메모
     * @type {string}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'memo': string;
    /**
     * 현재 유저의 총 포인트
     * @type {number}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'totalPoint'?: number;
    /**
     * 환급 가능한 포인트
     * @type {number}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'exchangeablePoint'?: number;
    /**
     * 총 환급 포인트
     * @type {number}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'totalExchangedPoint'?: number;
    /**
     * 누적 획득 총 포인트
     * @type {number}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'earnedPoint'?: number;
    /**
     * 최종 접속 일시
     * @type {string}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'lastAccessedAt': string;
    /**
     * 생성 일시
     * @type {string}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'createdAt': string;
    /**
     * 작성한 게시글 수
     * @type {number}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'postCnt': number;
    /**
     * 작성한 댓글 수
     * @type {number}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'commentCnt': number;
    /**
     * 뷰업에 연동된 SNS 계정
     * @type {ViewupSnsAccountOnPlatform}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'viewupSnsAccount': ViewupSnsAccountOnPlatform;
    /**
     * 뷰업에 연동된 SNS 계정
     * @type {ViewupPlusSnsAccountOnPlatform}
     * @memberof AdminGetUserByUserUuidDataDto
     */
    'viewupPlusSnsAccount': ViewupPlusSnsAccountOnPlatform;
}

export const AdminGetUserByUserUuidDataDtoLevelEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Both: 'both'
} as const;

export type AdminGetUserByUserUuidDataDtoLevelEnum = typeof AdminGetUserByUserUuidDataDtoLevelEnum[keyof typeof AdminGetUserByUserUuidDataDtoLevelEnum];


